var _rect, _rect2, _rect3, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPerf360(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 128,
    zoomAndPan: "magnify",
    viewBox: "0 0 96 95.999999",
    height: 128,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -9.6,
    width: 115.2,
    fill: "#ffffff",
    y: -9.6,
    height: 115.199999,
    fillOpacity: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -9.6,
    width: 115.2,
    fill: "#ffffff",
    y: -9.6,
    height: 115.199999,
    fillOpacity: 1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -9.6,
    width: 115.2,
    fill: "#ffffff",
    y: -9.6,
    height: 115.199999,
    fillOpacity: 1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#b3b3b3",
    d: "M 96.003906 48.003906 C 96.003906 60.28125 91.394531 71.484375 83.808594 79.972656 C 75.019531 89.8125 62.234375 96.003906 48.003906 96.003906 C 33.769531 96.003906 20.980469 89.8125 12.199219 79.972656 C 4.609375 71.484375 0 60.28125 0 48.003906 C 0 21.492188 21.488281 0 48.003906 0 C 74.511719 0 96.003906 21.492188 96.003906 48.003906 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#f2f2f2",
    d: "M 48.003906 56.84375 C 56.703125 56.84375 64.625 47 64.625 36.191406 C 64.625 25.980469 62.652344 15.882812 48.003906 15.882812 C 33.351562 15.882812 31.375 25.980469 31.375 36.191406 C 31.375 47 39.300781 56.84375 48.003906 56.84375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#f2f2f2",
    d: "M 83.808594 79.972656 C 75.019531 89.8125 62.234375 96.003906 48.003906 96.003906 C 33.769531 96.003906 20.980469 89.8125 12.199219 79.972656 C 12.046875 74.042969 15.992188 60.304688 36.128906 56.078125 C 39.574219 59.59375 43.816406 61.582031 48.003906 61.582031 C 52.191406 61.582031 56.425781 59.59375 59.871094 56.078125 C 80.011719 60.304688 83.957031 74.042969 83.808594 79.972656 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerf360);
export default __webpack_public_path__ + "static/media/perf360.20edfe029012da4be4bc915124da9177.svg";
export { ForwardRef as ReactComponent };